import React from 'react'
import useWindowSize from '../customHooks/useWindowSize';


type ImageData = {
  image: string;
  heading: string;
  buttonCta: string;
  url: string;
}

type SearchDropDownProps = {
  servicesData: ImageData[];
}

function SearchBarServices({ servicesData }: SearchDropDownProps): JSX.Element {
  const windowSize = useWindowSize()
  const isMobile = windowSize.width <= 640 ? true : false
  return (
    <div>
      {servicesData.length ? (
        <div className={`flex px-SM mb-SM justify-between mt-2XL max-w-screen-2xl mx-auto gap-3 md:gap-5 ${isMobile ? 'overflow-x-scroll' : ''}`}>
          {servicesData.map((imageData, i) => (
            <div key={i} className={`h-[303px] w-[258px] md:h-[566px] md:w-[453px] flex justify-center relative ${isMobile ? 'flex-shrink-0' : ''}`}>
              <img src={imageData.image} alt={imageData.heading} className='absolute w-full h-full object-cover'/> 
              <div className="font-bstSpyre text-white text-xl md:text-6xl text-center capitalize p-XL absolute">
                {imageData.heading}
              </div>
              <a href={imageData.url} 
                className="absolute text-white font-calibre text-base-2 bottom-[28.903.px] min-w-[150px] uppercase rounded-sm backdrop-blur-[25px] bg-opacity-50 bg-[#2E241D] text-center p-SM"
              >
                {imageData.buttonCta}
              </a>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  )
}

export default SearchBarServices